<template>
  <div>
    <el-card class="mb-3">
      <h5 v-if="baseInfo.scmName">{{ baseInfo.scmName }}</h5>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div style="height: 29px;line-height: 29px;overflow: hidden;">
            <span style="font-size: 14px; color: #606266">
              No：{{ baseInfo.amzPurchaseNo || 'New' }}
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                baseInfo.approvalStatus === 'D' ||
                baseInfo.approvalStatus === 'R'
                  ? 'danger'
                  : baseInfo.approvalStatus === 'Y'
                  ? 'success'
                  : baseInfo.approvalStatus === 'S'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_approvalStatus }}
            </el-tag>
            <el-divider direction="vertical" />
            <el-tag
              v-if="baseInfo.v_skuSalesChannel"
              size="mini"
              :type="
                baseInfo.skuSalesChannel === 'F'
                  ? 'success'
                  : baseInfo.skuSalesChannel === 'V'
                  ? 'warning'
                  : ''
              "
            >
              {{ baseInfo.v_skuSalesChannel }}
            </el-tag>
            <el-divider direction="vertical" />
            <span style="font-size: 14px; color: #606266">
              Update：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyTime || '--' }}
            </span>
          </div>
        </div>
        <div class="switch-tabs_wrappers">
          <div class="switch-tabs">
            <div
              v-for="item in switchTabs"
              :key="item.value"
              class="switch-tabs_items"
              :class="{
                active: item.value === activeName,
                disabled: item.disabled,
              }"
              @click="!item.disabled ? (activeName = item.value) : () => {}"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'">
        <EditForm
          ref="editForm"
          disabled
          :amzPurchaseChangeCode="amzPurchaseChangeCode"
          @loaded="baseLoaded"
        />
        <div class="d-flex justify-content-between mb-2 mt-2">
          <div>
            <span style="font-size: 14px; color: #606266">
              Create：{{ baseInfo.createByName || '--' }} at
              {{ baseInfo.createTime || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Review：{{ baseInfo.approvalByName || '--' }} at
              {{ baseInfo.approvedTime || '--' }}
            </span>
          </div>
        </div>
      </el-card>
      <el-card v-show="activeName == 'goods'">
        <SkuTable
          ref="skuTable"
          :disabled="disabled"
          :amzPurchaseChangeCode="amzPurchaseChangeCode"
          :approvalStatus="baseInfo.approvalStatus"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
export default {
  name: 'ecom-awsBiz-ftyPurchaseChange-detail',
  components: { EditForm, SkuTable },
  data() {
    return { baseInfo: {}, activeName: 'goods' }
  },
  computed: {
    switchTabs() {
      return [
        { label: '基本信息', value: 'base' },
        { label: '订单产品', value: 'goods' },
      ]
    },
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.isAllowChange ? this.pageType === 'detail' : true
    },
    amzPurchaseChangeCode() {
      return this.params.amzPurchaseChangeCode
    },
    isAllowChange() {
      return this.baseInfo?.isAllowChange || false
    },
  },
  methods: {
    baseLoaded(data) {
      this.baseInfo = data
      setTimeout(() => {
        this.$refs.skuTable.init()
      }, 0)
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
